// extracted by mini-css-extract-plugin
export default {"kybLoginDlg":"kybLoginDlg__btfbM","msg":"msg__V4ort","dmsg":"dmsg__JtdOJ","footer":"footer__s85jc","err1":"err1__X_1pQ","err2":"err2__KwcsY"};